export const SELF_CLOSING_MODAL_TIMEOUT_TIME_TO_CLOSE = 5000;

export enum SERVICE_MODALS_OPTIONS_STATES {
    POST_STARTING_OPTIONS,
    DELETING_POST,
    DELETED_POST,
    UNSUCCESSFUL_DELETING_POST,
    SHARING_POST,
    SHARING_LINK_COPIED_SUCCESSFULLY,
    UNSUCCESSFUL_COPYING_SHARING_LINK,
    UNSUCCESSFUL_SHORTENING_SHARING_LINK,
    COMMENT_STARTING_OPTIONS,
    COMMENT_PREVIEW_STARTING_OPTIONS,
    DELETING_COMMENT,
    DELETED_COMMENT,
    UNSUCCESSFUL_DELETING_COMMENT,
    REPORTING_CONTENT,
    REPORTED_CONTENT_RESTRICTED,
    SUCCESSFUL_CONTENT_REPORT,
    UNSUCCESSFUL_CONTENT_REPORT,
    TEXT_SUCCESSFULLY_COPIED_TO_CLIPBOARD,
    USER_PROFILE_PIC_STARTING_OPTIONS,
}

export enum SERVICE_MODALS_ERROR_STATES {
    DEFAULT,
    RESOURCE_SUSPENDED,
    RESOURCE_NOT_FOUND,
    USER_INACTIVE_OR_SUSPENDED,
    LIMIT_EXCEEDED_ERROR,
    NO_INTERNET,
    GENERAL_ERROR,
}
